if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            get_country();
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);


            // start custom code for shipping bar
          fetch('/cart.js')
            .then(response => {
              if (!response.ok) {
                throw new Error('Network response was not ok');
              }
              return response.json();
            })
            .then(cart => {
                    const getcountryCode = document.querySelector('#CartDrawer')?.getAttribute("data-location");
              
                    if(getcountryCode == 'ES' || getcountryCode == 'PT'){
                      var goal = document.querySelector('.shipping_bar .fsb')?.getAttribute("data-goal-1")*100;
                    } else if(getcountryCode == 'FR' || getcountryCode == 'IT' || getcountryCode == 'DE'  || getcountryCode == 'BE' || getcountryCode == 'NL' || getcountryCode == 'GB' || getcountryCode == 'AT' || getcountryCode == 'BG' || getcountryCode == 'CY' || getcountryCode == 'DK' || getcountryCode == 'EE' || getcountryCode == 'SK' || getcountryCode == 'SI' || getcountryCode == 'FI' || getcountryCode == 'GR' || getcountryCode == 'HU' || getcountryCode == 'IE' || getcountryCode == 'LV' || getcountryCode == 'LT' || getcountryCode == 'LU' || getcountryCode == 'MT' || getcountryCode == 'PL' || getcountryCode == 'CZ' || getcountryCode == 'RO' || getcountryCode == 'SE'){
                      var goal = document.querySelector('.shipping_bar .fsb')?.getAttribute("data-goal-2")*100;
                    }else{
                      var goal = document.querySelector('.shipping_bar .fsb')?.getAttribute("data-goal-3")*100;
                    }
                  
                    // const cartTotal = cart.total_price + cart.total_discount;
                    const cartTotal = cart.total_price ;
                    // console.log("gole:--",goal,"cartTotal:--",cartTotal);
    
                    // -------------- start code for setup shipping bar value and text ---------------
                    if (cartTotal < goal) {
                        const diff = goal - cartTotal;
                        const diff_price = Shopify.formatMoney(diff,'{{amount}}€') ;
                        const ship_text = document.querySelector('.shipping_bar .fsb')?.getAttribute("data-missing").replace("{{goal}}", `<strong>${diff_price}</strong>`);
                        document.querySelector(".fsb__msg").innerHTML = `<span>${ship_text}</span>`;
                        var shipValue = ((goal - diff) * 100) / goal;
                        document.querySelector(".ship-bar .ship-percentage").style.width = shipValue + "%";
                    }
                   else
                    {
                      const  ship_text = document.querySelector('.shipping_bar .fsb')?.getAttribute("data-congrats");
                      document.querySelector(".fsb__msg").textContent = ship_text;
                      document.querySelector(".ship-bar .ship-percentage").style.width = 100 + "%";
                   }
                    // -------------- end code for setup shipping bar value and text ---------------
    
                  // cart total based hide show gift product
                   setTimeout(function(){
                     hideshowGiftpdp();
                   },1000);
                
            })
            .catch(error => {
              console.error('Error fetching cart data:', error);
            });

        // end custom code for shipping bar


            // ---------- start code for add gift product --------
          document.querySelectorAll('cart-drawer .freegift-row .freegift-row-productlist .cart-btn').forEach(function(button) {
          button.addEventListener('click', function(e) {

            button.closest(".col").classList.add("Gift_active");
          var col_1 = document.querySelector('.freegift-row-productlist .col_1');
          var col_2 = document.querySelector('.freegift-row-productlist .col_2');
          var col_3 = document.querySelector('.freegift-row-productlist .col_3');
          col_1.classList.add("disable");
          col_2.classList.add("disable");
          col_3.classList.add("disable");
          const arr = [];
          const mainProdId = this.getAttribute('data-id');
          arr.push({id: mainProdId,quantity: 1,properties: {"is_free_product": true}});

          let formData = {'items': arr};
          // console.log('formData-',formData);
          fetch('/cart/add.js', {
              body: JSON.stringify(formData),
              credentials: 'same-origin',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With':'xmlhttprequest'
              },
              method: 'POST'
            }).then((response) => {
              return response.json();
            }).then((res) => {

            fetch(window.location.href, {
            method: "GET",
            headers: {
            "Content-Type": "text/html"
                  }
              })
            .then(response => response.text())
            .then(htmlContent => {
                      let doc = new DOMParser().parseFromString(htmlContent, "text/html");
                      let cartDrawerElement = doc.querySelector(".cart-drawer .drawer__contents");
                      if (cartDrawerElement) {
                          let currentCartDrawerElement = document.querySelector(".cart-drawer .drawer__contents");
                          if (currentCartDrawerElement) {
                              currentCartDrawerElement.outerHTML = cartDrawerElement.outerHTML;
                          }
                      }
                          hideshowGiftpdp();
          })
           .catch(error => {
            console.error("Error fetching and modifying HTML:", error);
            });
            console.log(res);
            
            }).catch((err) => {
              /* uh oh, we have error. */
              console.error(err)
            });
              });
            });

            

            // ---------- end code for add gift product --------
            
            
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}


function get_country(){
fetch('//get.geojs.io/v1/ip/country.json')
  .then(response => response.json())
  .then(location => {
    const getCountry = location.country;
    console.log('country==>', getCountry);
    document.querySelector("#CartDrawer")?.setAttribute("data-location", getCountry);
    var tier1Text = document.querySelector(".announcement-bar-section")?.getAttribute("data-tier1text");
    var tier2Text = document.querySelector(".announcement-bar-section")?.getAttribute("data-tier2text");
    var tier3Text = document.querySelector(".announcement-bar-section")?.getAttribute("data-tier3text");

    if(getCountry == 'ES' || getCountry == 'PT'){
    // Tier 1
      var anno_msg = tier1Text ;
      document.querySelectorAll(".announcement-bar-section .announcement-text-wrap span").forEach(function(span) {span.textContent = anno_msg;});
      document.querySelector(".shipping_bar .fsb")?.setAttribute("data-goal", "50");
      const el = document.querySelector(".freegift-row-productlist");
      if (el) {
        el.setAttribute("gift1", "7500");
        el.setAttribute("gift2", "10000");
        el.setAttribute("gift3", "15000");
      }
      document.querySelector(".freegift-row-productlist .card-image.first .price-barckpoint").innerHTML="From 75€";
      document.querySelector(".freegift-row-productlist .card-image.sec .price-barckpoint").innerHTML="From 100€";
      document.querySelector(".freegift-row-productlist .card-image.third .price-barckpoint").innerHTML="From 150€";

  } else if(getCountry == 'FR' || getCountry == 'IT' || getCountry == 'DE'  || getCountry == 'BE' || getCountry == 'NL' || getCountry == 'GB' || getCountry == 'AT' || getCountry == 'BG' || getCountry == 'CY' || getCountry == 'DK' || getCountry == 'EE' || getCountry == 'SK' || getCountry == 'SI' || getCountry == 'FI' || getCountry == 'GR' || getCountry == 'HU' || getCountry == 'IE' || getCountry == 'LV' || getCountry == 'LT' || getCountry == 'LU' || getCountry == 'MT' || getCountry == 'PL' || getCountry == 'CZ' || getCountry == 'RO' || getCountry == 'SE'){
    // Tier 2 
      var anno_msg = tier2Text ;
      document.querySelectorAll(".announcement-bar-section .announcement-text-wrap span").forEach(function(span) {span.textContent = anno_msg;});
      document.querySelector(".shipping_bar .fsb")?.setAttribute("data-goal", "70");
      const el = document.querySelector(".freegift-row-productlist");
      if (el) {
        el.setAttribute("gift1", "9500");
        el.setAttribute("gift2", "12000");
        el.setAttribute("gift3", "17000");
      }
      document.querySelector(".freegift-row-productlist .card-image.first .price-barckpoint").innerHTML="From 95€";
      document.querySelector(".freegift-row-productlist .card-image.sec .price-barckpoint").innerHTML="From 120€";
      document.querySelector(".freegift-row-productlist .card-image.third .price-barckpoint").innerHTML="From 170€";

  } else {
    // Tier 3
      var anno_msg = tier3Text ;
      document.querySelectorAll(".announcement-bar-section .announcement-text-wrap span").forEach(function(span) {span.textContent = anno_msg;});
      document.querySelector(".shipping_bar .fsb")?.setAttribute("data-goal", "100");
      const el = document.querySelector(".freegift-row-productlist");
      if (el) {
        el.setAttribute("gift1", "7500");
        el.setAttribute("gift2", "10000");
        el.setAttribute("gift3", "15000");
      }
      document.querySelector(".freegift-row-productlist .card-image.first .price-barckpoint").innerHTML="From 75€";
      document.querySelector(".freegift-row-productlist .card-image.sec .price-barckpoint").innerHTML="From 100€";
      document.querySelector(".freegift-row-productlist .card-image.third .price-barckpoint").innerHTML="From 150€";
      
  }
  })
  .catch(error => {
    console.error('Error fetching country:', error);
  });
}

// custom function
function hideshowGiftpdp()
{
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      // console.log("cart_total:-",cart.total_price);
        var gift_1 = document.querySelector('.freegift-row-productlist')?.getAttribute("gift1");
        var gift_2 = document.querySelector('.freegift-row-productlist')?.getAttribute("gift2");
        var gift_3 = document.querySelector('.freegift-row-productlist')?.getAttribute("gift3");
        
        var col_1 = document.querySelector('.freegift-row-productlist .col_1');
        var col_2 = document.querySelector('.freegift-row-productlist .col_2');
        var col_3 = document.querySelector('.freegift-row-productlist .col_3');
        var cartTotal = cart.original_total_price;
        // console.log("cartTotal:--",cartTotal,"gift_1:--",gift_1,"gift_2:--",gift_2,"gift_3:--",gift_3);
    
        const giftContainer = document.querySelector(".freegift-row-productlist");
        const gift1 = parseInt(giftContainer?.getAttribute("gift1") || 0, 10);
        const gift2 = parseInt(giftContainer?.getAttribute("gift2") || 0, 10);
        const gift3 = parseInt(giftContainer?.getAttribute("gift3") || 0, 10);
        const maxGiftPrice = Math.max(gift1, gift2, gift3);                
        var is_gift_avail = false;
    
      cart.items.forEach(function(item, index) {
              if (item.properties && item.properties['is_free_product'] === true) 
              {
                 is_gift_avail = true;
              }
             if (cart.items.length === 1 && /free|gift/i.test(cart.items[0].title))
              {
                 const itemEl = document.querySelector(`[data-giftid='${item.id}']`);
                        if (itemEl) {
                          const removeBtn = itemEl.querySelector('cart-remove-button');
                          if (removeBtn) {
                            removeBtn.click();
                          }
                        }
              }
          });
        // console.log("check gift avail product-form:--",is_gift_avail);
                
                 if (cartTotal < gift_1) {
                    // console.log("iff 1");
                    var gift1_id = document.querySelector(".freegift-row-productlist .col_1")?.getAttribute("data-vid");
                      // console.log(gift1_id) ;
                    var giftPriceDiff = gift_1 - cartTotal;
                    var diff_price = Shopify.formatMoney(giftPriceDiff,'{{amount}}€') ;
                    document.querySelector(".freegift-row-header p").innerHTML = `<strong>${diff_price}</strong> left to get a free gift`;
                    col_1.classList.add("disable");
                    col_2.classList.add("disable");
                    col_3.classList.add("disable");
                    // }
                    var ship_width = (gift1-giftPriceDiff) * 100 / maxGiftPrice;
                    document.querySelector(".freegift-bar .freegift-percentage").style.width = ship_width + "%";
                    if(is_gift_avail)
                    {
                      col_1.classList.add("disable");
                      col_2.classList.add("disable");
                      col_3.classList.add("disable");
                    }
                   // Remove free gift items from cart
                   cart.items.forEach(function(item) {
                      if (item.properties && item.properties['is_free_product'] === true && String(item.id) === String(gift1_id)) {
                        const itemEl = document.querySelector(`[data-giftid='${item.id}']`);
                        if (itemEl) {
                          const removeBtn = itemEl.querySelector('cart-remove-button');
                          if (removeBtn) {
                            removeBtn.click();
                          }
                        }
                      }
                    });                  
                      // end Remove free gift items from cart
                  } 
                  else if (cartTotal >= gift_1 && cartTotal < gift_2) {
                    // console.log("iff 2");
                    var gift2_id = document.querySelector(".freegift-row-productlist .col_2")?.getAttribute("data-vid");
                      // console.log(gift2_id) ;
                    var giftPriceDiff = gift_2 - cartTotal;
                    var diff_price = Shopify.formatMoney(giftPriceDiff,'{{amount}}€') ;
                    document.querySelector(".freegift-row-header p").innerHTML = `<strong>${diff_price}</strong> left to get your premium gift.`;
                    col_1.classList.remove("disable");
                    col_2.classList.add("disable");
                    col_3.classList.add("disable");
                    var ship_width = (gift2-giftPriceDiff) * 100 / maxGiftPrice;
                    document.querySelector(".freegift-bar .freegift-percentage").style.width = ship_width + "%";
                     if(is_gift_avail)
                      {
                        col_1.classList.add("disable");
                        col_2.classList.add("disable");
                        col_3.classList.add("disable");
                      }
                    // Remove free gift items from cart
                     cart.items.forEach(function(item) {
                      if (item.properties && item.properties['is_free_product'] === true && String(item.id) === String(gift2_id)) {
                        const itemEl = document.querySelector(`[data-giftid='${item.id}']`);
                        if (itemEl) {
                          const removeBtn = itemEl.querySelector('cart-remove-button');
                          if (removeBtn) {
                            removeBtn.click();
                          }
                        }
                      }
                    });      
                      // end Remove free gift items from cart
                  } 
                  else if (cartTotal >= gift_2 && cartTotal < gift_3) {
                     // console.log("iff 3");
                    var gift3_id = document.querySelector(".freegift-row-productlist .col_3")?.getAttribute("data-vid");
                      // console.log(gift3_id) ;
                    var giftPriceDiff = gift_3 - cartTotal;
                    var diff_price = Shopify.formatMoney(giftPriceDiff,'{{amount}}€') ;
                    document.querySelector(".freegift-row-header p").innerHTML = `<strong>${diff_price}</strong> left to get your premium gift.`;
                    col_1.classList.remove("disable");
                    col_2.classList.remove("disable");
                    col_3.classList.add("disable");
                    var ship_width = (gift3-giftPriceDiff) * 100 / maxGiftPrice;
                    document.querySelector(".freegift-bar .freegift-percentage").style.width = ship_width + "%";
                     if(is_gift_avail)
                    {
                      col_1.classList.add("disable");
                      col_2.classList.add("disable");
                      col_3.classList.add("disable");
                    }
                     // Remove free gift items from cart
                     cart.items.forEach(function(item) {
                      if (item.properties && item.properties['is_free_product'] === true && String(item.id) === String(gift3_id)) {
                        const itemEl = document.querySelector(`[data-giftid='${item.id}']`);
                        if (itemEl) {
                          const removeBtn = itemEl.querySelector('cart-remove-button');
                          if (removeBtn) {
                            removeBtn.click();
                          }
                        }
                      }
                    });      
                      // end Remove free gift items from cart
                  } else {
                    // console.log("els");
                    document.querySelector(".freegift-row-header p").textContent ="Congratulations! Select your free gift:"
                    col_1.classList.remove("disable");
                    col_2.classList.remove("disable");
                    col_3.classList.remove("disable");
                    document.querySelector(".freegift-bar .freegift-percentage").style.width = 100 + "%";
                     if(is_gift_avail)
                    {
                      col_1.classList.add("disable");
                      col_2.classList.add("disable");
                      col_3.classList.add("disable");
                    }
                  }
                          var menu = ['', '', '']
                          new Swiper('.cart-drawer-rc', {
                            loop: true,
                            slidesPerView: 1,
                            spaceBetween: 10,
                            pagination: {
                              el: ".cart-drawer-rc .swiper-pagination",
                              clickable: true,
                              renderBullet: function (index, className) {
                                  return '<span class="' + className + '">' + (menu[index]) + '</span>';
                                },
                           }
                          });
      
    })
    .catch(error => console.error("Error fetching cart:", error));

}


